import React, { Component } from "react";
import { invokeApig } from "../../libs/awsLib";
import { Col } from "react-bootstrap";
import NewUnit from "./NewUnit";

export default class UnitActions extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isDeleting: false,
            show: false,
            unit:[]
        };
      
        this.handleClose = this.handleClose.bind(this);

    }

    handleClose() {
        this.setState({ show: false });
    }
    
    saveUnit(unit) {
        return invokeApig({
          path: `/unit/${this.props.unitId}`,
          method: "PUT",
          body: unit
        });
      }

  handleAlertSuccess = (message) => {
	this.props.onAlertSuccess(message);
  }
  handleAlertError = (message) => {
    this.props.onAlertError(message);
  }

  render(){
    return(
        <div className="col-lg col-12">
            <Col lg={12}>
                <NewUnit {...this.props} unitId={this.props.unitId} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
            </Col>
        </div>
    );
  }
}




















// WEBPACK FOOTER //
// ./src/containers/unit/UnitActions.js